import i18next from 'i18next';
import { appendDateToFilename } from './dateUtils';

export const exportData = async (route, filters, fileName = 'export.xlsx') => {
  try {
    fileName = appendDateToFilename(fileName);
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
    const token = localStorage.getItem('authToken');
    const response = await fetch(apiUrl + route, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: 'Bearer ' + token,
        lang: i18next.language || 'en',
      },
      body: JSON.stringify(filters),
    });
    // console.log('response', JSON.parse(response));
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    // const contentDisposition = response.headers.get('Content-Disposition');

    // if (contentDisposition) {
    //   const matches = contentDisposition.match(/filename="(.+)"/);
    //   if (matches && matches[1]) {
    //     fileName = matches[1];
    //   }
    // }

    const blob = await response.blob();

    const link = document.createElement('a');
    const fileURL = URL.createObjectURL(blob);

    link.href = fileURL;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(fileURL);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};
